import { useFetchers } from "@website/fetcher/use-fetcher";
import { ReserveCommentPropertiesType } from "@website/widget/reserve-comment";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef, useState } from "react";
import { fetchHotelReviewData } from "./index.server";

export const useHotelRoomComments = (properties: {
  hotelId: number;
  roomId?: string | number;
}) => {
  const router = useRouter();
  const initialFilters = {
    attitude:
      String(
        router.query?.["filter_attitude"] === "all"
          ? ""
          : router.query?.["filter_attitude"] ?? ""
      ) || ""
  };
  const { hotelId, roomId } = properties;
  const total = useRef(0);
  const page = useRef(1);
  const [pages, setPages] = useState<Array<number>>([1]);
  const [isInsideDetail, setIsInsideDetail] = useState(false);
  const [filters, setFilters] =
    useState<Record<string, string>>(initialFilters);

  const commentsQueries = useFetchers({
    queries: (pages || [roomId])?.map((page) => ({
      queryKey: [
        "hotelReviewData",
        hotelId,
        page,
        "hotel-domestic",
        isInsideDetail ? filters : initialFilters,
        roomId
      ],
      enabled: Boolean(roomId),
      queryFn: ({ queryKey }: { queryKey: Array<unknown> }) =>
        fetchHotelReviewData(
          queryKey[1],
          queryKey[2],
          String(queryKey[3]),
          queryKey[4] as Record<string, string>,
          queryKey[5] || ""
        )
    }))
  });

  useEffect(() => {
    page.current = commentsQueries.flatMap(({ data }) => data?.page)?.[
      commentsQueries.length - 1
    ];
    total.current = commentsQueries.flatMap(({ data }) => data?.total)?.[
      commentsQueries.length - 1
    ];
  }, [commentsQueries]);

  const onLoadMore = useCallback(() => {
    if (page.current < Math.ceil(total.current / 5))
      setPages((previousState) => [...previousState, page.current + 1]);
  }, [setPages]);

  const onLoadFilter = useCallback(
    (filter: Record<string, string>, isInsideDetail?: boolean) => {
      setIsInsideDetail(isInsideDetail);
      if (filter?.["attitude"] === "all") filter["attitude"] = "";
      setFilters((previousState) => ({ ...previousState, ...filter }));
    },
    []
  );

  return {
    onLoadMoreRoomComments: onLoadMore,
    onLoadRoomCommentsFilter: onLoadFilter,
    roomCommentsFilters: initialFilters,
    roomComments:
      (commentsQueries.flatMap(
        ({ data }) => data?.rateReviews || []
      ) as unknown as Array<ReserveCommentPropertiesType>) || [],
    isRoomCommentsLoading: commentsQueries.some((item) => item.isFetching)
  };
};
